var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var OscillatorCornerConcavePadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(OscillatorCornerConcavePadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
OscillatorCornerConcavePadGeneratorInteractionModel.$class = 'OscillatorCornerConcavePadGeneratorInteractionModel';

module.exports = OscillatorCornerConcavePadGeneratorInteractionModel;

OscillatorCornerConcavePadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);
    
    this.horizontalTerminalGapMin = this.shadow("horizontalTerminalGapMin",
        function() {
            return self.data.horizontalTerminalGapMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.horizontalTerminalGapMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.horizontalTerminalGapMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.horizontalTerminalGapMax = this.shadow("horizontalTerminalGapMax",
        function() {
            return self.data.horizontalTerminalGapMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.horizontalTerminalGapMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.horizontalTerminalGapMax, this.userSettingsModel.distanceUnit
        ]
    );

    this.verticalTerminalGapMin = this.shadow("verticalTerminalGapMin",
        function() {
            return self.data.verticalTerminalGapMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.verticalTerminalGapMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.verticalTerminalGapMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.verticalTerminalGapMax = this.shadow("verticalTerminalGapMax",
        function() {
            return self.data.verticalTerminalGapMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.verticalTerminalGapMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.verticalTerminalGapMax, this.userSettingsModel.distanceUnit
        ]
    );
};

OscillatorCornerConcavePadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

OscillatorCornerConcavePadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

OscillatorCornerConcavePadGeneratorInteractionModel.prototype.getInspectorElementForTerminalGap = function() {
    var horizontalTerminalGap = PackageGeneratorInspectorConfig.getMinMaxRow('D1', this.LCLZ('hTerminalGap', 'Horizontal Terminal Gap'), false, this.horizontalTerminalGapMin, false, this.horizontalTerminalGapMax, this.userSettingsModel.distanceUnit);
    var verticalTerminalGap = PackageGeneratorInspectorConfig.getMinMaxRow('E1', this.LCLZ('vTerminalGap', 'Vertical Terminal Gap'), false, this.verticalTerminalGapMin, false, this.verticalTerminalGapMax, this.userSettingsModel.distanceUnit);

    return [horizontalTerminalGap, verticalTerminalGap];
};

OscillatorCornerConcavePadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintOscConcave));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadGap1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForTerminalGap());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};